import { Component, Inject } from '@angular/core';
import { Form, FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SsoAuthService } from '../../../sso-auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-mobile-change-popup',
  imports: [FormsModule, ReactiveFormsModule],
  templateUrl: './mobile-change-popup.html',
  styleUrl: './mobile-change-popup.scss'
})
export class MobileChangePopup {
  mobile: FormControl = new FormControl('', [Validators.required, Validators.pattern(/^[6-9]\d{9}$/), Validators.maxLength(10), Validators.minLength(10)]);
  otp: FormControl = new FormControl('', [Validators.required, Validators.pattern(/^[1-9][0-9]{5}$/), Validators.maxLength(6), Validators.minLength(6)]);
  otpId: any = '';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dislogRef: MatDialogRef<MobileChangePopup>,
    private authService: SsoAuthService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    console.log(this.data);
    this.mobile.setValue(this.data);
  }

  // This runs whenever user types
  onInput(event: Event, type: 'mobile' | 'otp') {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
    if(type === 'mobile')
      this.mobile.setValue(input.value, { emitEvent: false });
    if(type === 'otp')
      this.otp.setValue(input.value, { emitEvent: false });
  }

  getOtp() {
    if(this.mobile && this.mobile.dirty && this.mobile.getRawValue() !== this.data){
        const payload = {
        contactNo: String(this.mobile.getRawValue())
      }
      this.authService.updatePhoneNo(payload).subscribe({
        next: (res) => {
          // this.isUpdateNo = true
          this.otpId = res.data.otpRequestId
          console.log(this.otpId, this.otp.getRawValue().length)
          if(this.otpId)
            this.toastr.success('OPT sent successfully!')
        },
        error: (err) => console.error('Error updating phone No.', err)
      })
    }
  }

  updateMobile() {
    if(this.otp.valid) {
      const payload = {
        id: Number(this.otpId),
        otp: this.otp.getRawValue()
      }
      this.authService.verifyContactNo(payload).subscribe({
        next: (res) => {
          console.log(res);
          this.close(res?.data?.updatedContactNo)
        },
        error: (err) => console.error('Error verifying mobile, err')
      })
    }
  }

  close(value: any) {
    this.dislogRef.close(value);
  }
}
